/*
  GoKwik cart-state compatibility shim (additive — does NOT change snippets/gokwik.liquid).

  snippets/gokwik.liquid declares `var cart = {{ cart | json }}`, which is rendered once when the page
  loads. After an AJAX add / quantity change / remove (cart drawer, cart page, product form, product
  cards) that global kept the page-load cart, so GoKwik could read a stale cart.

  This script only OBSERVES successful cart mutations made with fetch() or XMLHttpRequest
  (/cart/add, /cart/change, /cart/update, /cart/clear — with or without .js) and then refreshes the
  global `cart` (window.cart) from the response, or from /cart.js when the response is not a full cart
  (e.g. /cart/add returns the added line item). Requests and responses are passed through untouched.
  It fires `gokwik:cart-synced` on document with the fresh cart.
*/
(function () {
  if (window.__gokwikCartSync) return;
  window.__gokwikCartSync = true;

  var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|#|$)/;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var seq = 0; // newest mutation wins
  var inFlight = false;
  var again = false;

  function urlOf(input) {
    try {
      if (typeof input === 'string') return input;
      if (input && input.url) return input.url;
      return String(input || '');
    } catch (e) {
      return '';
    }
  }

  function isFullCart(data) {
    return data && typeof data === 'object' && Array.isArray(data.items) && typeof data.item_count === 'number' && 'total_price' in data;
  }

  function apply(data) {
    var fresh = {};
    for (var k in data) if (k !== 'sections' && Object.prototype.hasOwnProperty.call(data, k)) fresh[k] = data[k];
    window.cart = fresh; // `var cart` in gokwik.liquid is this same global binding
    try {
      document.dispatchEvent(new CustomEvent('gokwik:cart-synced', { detail: fresh }));
    } catch (e) {}
  }

  function refresh() {
    if (!nativeFetch) return;
    if (inFlight) {
      again = true;
      return;
    }
    inFlight = true;
    var mySeq = seq;
    nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (isFullCart(data) && mySeq === seq) apply(data);
      })
      .catch(function () {})
      .then(function () {
        inFlight = false;
        if (again || mySeq !== seq) {
          again = false;
          refresh();
        }
      });
  }

  function onMutation(responseData) {
    seq++;
    if (isFullCart(responseData)) {
      apply(responseData);
      return;
    }
    refresh();
  }

  if (nativeFetch) {
    window.fetch = function (input, init) {
      var p = nativeFetch.apply(window, arguments);
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method !== 'GET' && MUTATION_RE.test(urlOf(input))) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res
            .clone()
            .json()
            .then(onMutation, function () {
              onMutation(null);
            });
        }).catch(function () {});
      }
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__gkCartMutation = String(method || 'GET').toUpperCase() !== 'GET' && MUTATION_RE.test(String(url || ''));
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__gkCartMutation) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          var data = null;
          try {
            data = typeof this.response === 'object' && this.response ? this.response : JSON.parse(this.responseText);
          } catch (e) {}
          onMutation(data);
        });
      }
      return send.apply(this, arguments);
    };
  }

  // Back/forward cache restores a page with an old `cart`; refresh it.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      seq++;
      refresh();
    }
  });
})();
